xtend = require 'xtend'
{ currentLocale } = require '@trello/locale'

module.exports = (baseOptions) -> xtend baseOptions, locale: currentLocale



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-options.coffee